
import { Component, Prop, Vue } from 'bits/vue'
import OzCenterModal from 'library/v4/components/OzCenterModal.vue'
import OzDrawerDraggable from 'library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from 'library/v4/components/OzDrawerStatic.vue'
/**
 * Screen size aware drawer modal that renders OzDrawer on phone and OzCenterModal on desktop. Used in Content picker.
 */

@Component({ components: { OzDrawerStatic, OzDrawerDraggable, OzCenterModal } })
export default class OzScreenSizeAwareCenterModal extends Vue {
  @Prop({ default: false }) isPhone!: boolean
  @Prop({ default: false }) isDraggableDrawer!: boolean
}
